import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

const PRItem = (props) => {
  const { exerciseName, value, delta, units = "kgs" } = props;
  return (
    <div>
      <div className="pr-item">
        <div>{exerciseName}</div>
        <div>
          {value} <span className="units">{units}</span>
        </div>
        <div className="pr-delta">
          <SvgIcon
            noFilterOnLight={true}
            src={
              delta >= 0
                ? "/img/new-icons/arrow-up-blue.svg"
                : "/img/new-icons/red-arrow-down.svg"
            }
          />
          <div className="delta">{delta}</div>
          <div className="units">{units}</div>
        </div>
      </div>
    </div>
  );
};

export default PRItem;
